<template>
  <div class="materialDialog">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      class="cardList"
      :before-close="handleCloseDialog"
      :lock-scroll="false"
      top="5vh"
    >
      <div v-if="materialQuery.length == 0" class="empty">
        <el-empty description="暂无准考证"></el-empty>
      </div>
      <div v-if="materialQuery.length > 0" class="materialCard">
        <div class="iframeCard">
          <iframe
            id="documentIframe"
            border="0"
            :src="currentPdf"
            style="width: 100%; height: 730px; border: none"
          ></iframe>
        </div>
        <div class="materialList">
          <div
            v-for="(v, key) in materialQuery"
            :key="key"
            class="materialBox"
            :class="['materialBox', { active: activeIndex == key }]"
            @click="handleChangePdfFn(v, key)"
          >
            <div>{{ v.jobInfo }}</div>
            <div>{{ v.jobLevel }}</div>
            <div>{{ v.idCard }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import to from 'await-to'
import { cardInfoQueryFn } from '@/api/apply'
export default {
  data() {
    return {
      dialogVisible: false,
      title: '',
      materialQuery: [],
      currentPdf: '',
      activeIndex: 0,
    }
  },
  methods: {
    show(row) {
      if (row.id) {
        this.title = row.name + '名下准考证'
        this.dialogVisible = true
        this.handleGetMaterialListFn(row.id)
      }
    },
    async handleGetMaterialListFn(id) {
      const [res, err] = await to(cardInfoQueryFn({ id: id }))
      if (err) return this.$message.warning(err.msg)
      this.materialQuery = res.data
      if (this.materialQuery.length > 0) {
        this.currentPdf = this.materialQuery[0].url
      }
    },
    handleChangePdfFn(v, k) {
      this.activeIndex = k
      this.currentPdf = v.url
    },
    handleCloseDialog() {
      this.dialogVisible = false
      this.currentPdf = ''
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  .materialCard {
    display: flex;
    .iframeCard {
      width: 700px;
    }
    .materialList {
      margin-left: 10px;
      flex-grow: 1;
      background: #f2f2f2;
      padding: 15px 10px;
      max-height: 700px;
      overflow-x: hidden;
      overflow-y: scroll;
      .materialBox {
        background: #d7d7d7;
        margin-bottom: 20px;
        border-radius: 4px;
        padding: 10px;
        color: #333;
        cursor: pointer;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .active {
        background: #3671bf;
        margin-bottom: 20px;
        border-radius: 4px;
        padding: 10px;
        color: #fff;
      }
    }
    .materialList::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
